<div class="timesheet-info">


 <!--

  <ng-template #errors>
    <ul>
      <li *ngFor="let msg of error.messages">
        {{msg}}
      </li>
    </ul>
  </ng-template>

  <div *ngIf="onHasErrors()" style="float: right;color:lightsalmon;" placement="top" [ngbPopover]='errors' triggers="mouseenter:mouseleave">
    <i class="fa fa-exclamation-triangle"></i>
  </div>
   -->

  <ng-template [ngIf]="hasMeal1Info()"><div class="hourCell" [ngStyle]="line.meal1Validation.style()">

    <ng-template #meal1>
      <ng-template [ngIf]="!line.meal1Validation.isSuccess()"><ul>
        <li *ngFor="let msg of line.meal1Validation.messages">
          {{msg}}
        </li>
      </ul></ng-template>
    </ng-template>


    <ng-template [ngIf]="!line.meal1Validation.isSuccess()"><div style="float:right;"  placement="top" [ngbPopover]='meal1' triggers="mouseenter:mouseleave">
      <i class="fa fa-exclamation-triangle"></i>
    </div></ng-template>


    <ng-template #ep1>
      <div [innerHtml] = "explainMeal1()"></div>
    </ng-template>

    <div style="float: left;" placement="top" [ngbPopover]='ep1' triggers="mouseenter:mouseleave">
      <i style="font-size: small;" class="fa fa-info"></i>
    </div>

    <div class="zoomable">
      <ng-template [ngIf]="needToSpecifyHours()"><div class="hourCell-main">
        - {{retrieveWhatToRemoveForMeal1()| displayMinute}}
      </div></ng-template>
      <ng-template [ngIf]="hasMeal1Info()"><div class="hourCell-bottom">
        <ng-template [ngIf]="hasMeal1ScheduledInfo()"><div class="hourCell-bottom-left">
          {{currentEmployeeHoraire.sdMeal1Start | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.sdMeal1End | myDateFormat:'LT':'xx:xx'}}
        </div></ng-template>

        <ng-template [ngIf]="hasMeal1PunchInfo()"><div class="hourCell-bottom-right">
          {{ currentEmployeeHoraire.tsMeal1StartPunchDt | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.tsMeal1EndPunchDt | myDateFormat:'LT':'xx:xx'}}
        </div></ng-template>
      </div></ng-template>
    </div>
  </div></ng-template>



  <ng-template [ngIf]="hasMeal2ApprovedTS()"><div class="hourCell"  [ngStyle]="line.meal2Validation.style()">

    <ng-template #meal2>
      <ng-template [ngIf]="!line.meal2Validation.isSuccess()"><ul>
        <li *ngFor="let msg of line.meal2Validation.messages">
          {{msg}}
        </li>
      </ul></ng-template>
    </ng-template>


    <ng-template [ngIf]="!line.meal2Validation.isSuccess()"><div style="float:right"  placement="top" [ngbPopover]='meal2' triggers="mouseenter:mouseleave">
      <i class="fa fa-exclamation-triangle"></i>
    </div></ng-template>



    <ng-template #ep2>
      <div [innerHtml] = "explainMeal2()"></div>
    </ng-template>

    <div style="float: left;" placement="top" [ngbPopover]='ep2' triggers="mouseenter:mouseleave">
      <i style="font-size: small;" class="fa fa-info"></i>
    </div>

    <div class="zoomable">
      <div class="hourCell-main">
        <!--{{currentEmployeeHoraire.retrieveMeal2Duration() | displayMinute}}-->
        - {{retrieveWhatToRemoveForMeal2() | displayMinute}}
      </div>
      <ng-template [ngIf]="hasMeal2Info()"><div  class="hourCell-bottom">
        <ng-template [ngIf]="hasMeal2ScheduledInfo()"><div class="hourCell-bottom-left">
          {{currentEmployeeHoraire.sdMeal2Start | myDateFormat:'LT':'xx:xx' }}-{{currentEmployeeHoraire.sdMeal2End | myDateFormat:'LT':'xx:xx'}}
        </div></ng-template>

        <ng-template [ngIf]="hasMeal2PunchInfo()"><div class="hourCell-bottom-right">
          {{currentEmployeeHoraire.tsMeal2StartPunchDt | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.tsMeal2EndPunchDt | myDateFormat:'LT':'xx:xx'}}
        </div></ng-template>
      </div></ng-template>
    </div>

  </div></ng-template>


</div>
